import React from 'react'

import Flex from 'styled-flex-component'

import brandIcon from '@images/brand-icon.png'
import Theme from '@theme'
import { H1 } from '@tribegroup'
import AuthFormStyled from './AuthForm.styled'

export interface IAuthForm {
  title: React.ReactNode
  subtitle?: React.ReactNode
}

const AuthForm = ({ title, subtitle, children }: any) => (
  <AuthFormStyled>
    <Flex center column alignCenter className="header">
      {/* Decorative brand icon — the adjacent H1 conveys the heading. `title` is a
          ReactNode (FormattedMessage), so binding it to `alt` produced "[object Object]". */}
      <img alt="" width={40} src={brandIcon} />
      <H1 color={Theme.grey900Color}>{title}</H1>
      {subtitle}
    </Flex>
    {children}
  </AuthFormStyled>
)

export default AuthForm
